/* JOLI POT, pages d'occasion (assets/jp-occasion.js) : mini-configurateur, bandeau date limite, « Lire la suite » */
(function () {
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sansAccent(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

  /* ---- Police manuscrite des aperçus ---- */
  var policeOk = false, aRedessiner = [];
  function chargerPolice() {
    if (policeOk) return; policeOk = true;
    /* Sacramento est déclarée par la section (fichier assets/jp-police-sacramento.woff2), plus aucun appel à Google Fonts */
    if (document.fonts && document.fonts.load) document.fonts.load('20px "Sacramento"').then(function () { CTX = null; aRedessiner.forEach(function (f) { f(); }); }, function () {});
  }
  var CTX = null;
  function largeurTxt(t) {
    if (!CTX) { try { CTX = document.createElement('canvas').getContext('2d'); } catch (e) {} }
    if (!CTX) return t.length * 0.4;
    CTX.font = "1px Sacramento, 'Brush Script MT', cursive"; return CTX.measureText(t).width;
  }
  function decouper(txt, max) {
    var mots = txt.split(' '), l = [], c = '';
    mots.forEach(function (w) { if ((c + ' ' + w).trim().length > max && c) { l.push(c); c = w; } else c = (c + ' ' + w).trim(); });
    if (c) l.push(c); return l;
  }
  /* Même mise en page que le configurateur : 2 lignes pour une phrase courte, plus petit plutôt que d'empiler les mots */
  function texteSvg(t, petit, milieu, coul) {
    var txt = String(t).replace(/\s+/g, ' ').trim() || ' ';
    var zW = petit ? 34 : 50, zH = petit ? 40 : 58, cap = petit ? 11 : 15, PAS = petit ? 10 : 14, fMin = petit ? 6.4 : 8.5;
    var nbMots = txt.split(' ').length, cands = [], best = null, fMax = 0;
    for (var cmax = 5; cmax <= 22; cmax++) {
      var ll = decouper(txt, cmax); if (ll.length > 4 || ll.join(' ').split(' ').length !== nbMots) continue;
      var w = Math.max.apply(null, ll.map(largeurTxt)) || 1;
      if (ll.length * PAS > zH) continue; var f = Math.min(cap, zW / w);
      cands.push({ l: ll, f: f }); if (f > fMax) fMax = f;
    }
    cands.forEach(function (c) { if (c.f < Math.min(fMin, fMax)) return; if (c.l.length === 1 && nbMots > 2 && txt.length > 14) return; if (!best || c.l.length < best.l.length || (c.l.length === best.l.length && c.f > best.f)) best = c; });
    var l, fs;
    if (best) { l = best.l; fs = best.f; } else { l = decouper(txt, petit ? 9 : 10).slice(0, 4); fs = Math.min(cap, zW / (Math.max.apply(null, l.map(largeurTxt)) || 1)); }
    var hOff = fs * 0.3 + (petit ? 10 : 15), bas = (l.length - 1) * PAS + hOff, y0 = milieu - (bas - fs * 0.72) / 2;
    return { svg: l.map(function (x, i) { return '<text x="100" y="' + (y0 + i * PAS).toFixed(1) + '" font-family="Sacramento, \'Brush Script MT\', cursive" font-size="' + fs.toFixed(1) + '" text-anchor="middle" fill="' + coul + '">' + esc(x) + '</text>'; }).join(''), coeur: y0 + (l.length - 1) * PAS + hOff };
  }
  var COEUR = 'c-1-1-5-3.5-5-6 0-1.6 1-2.6 2.6-2.6 1 0 1.8.6 2.4 1.6.6-1 1.4-1.6 2.4-1.6 1.6 0 2.6 1 2.6 2.6 0 2.5-4 5-5 6z';
  /* Formes identiques au configurateur, au bon de commande et à la page entreprise */
  function genre(style) {
    var s = sansAccent(style);
    if (s === 'kit' || /kit/.test(s)) return 'kit';
    if (/flora|crochet/.test(s)) return 'flora';
    if (/bougie/.test(s)) return /terra/.test(s) ? 'bougie-terra' : 'bougie';
    if (/dor/.test(s)) return 'dore';
    if (/terra/.test(s) && !/blanc|bicolore|classique/.test(s)) return 'terra';
    return 'classique';
  }
  function dessin(style, msg, mini) {
    var g = genre(style), petit = g === 'flora', terra = g === 'terra' || g === 'flora' || g === 'bougie-terra';
    var coul = terra ? '#fff' : '#1d1a17';
    var s = '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">';
    if (g === 'kit') s += '<ellipse cx="100" cy="166" rx="62" ry="9" fill="#b9644f"/><rect x="40" y="157" width="120" height="9" rx="3" fill="#ad523f"/>';
    if (petit) {
      s += '<path d="M72 96h56l-7 62H79z" fill="#c4704f"/><rect x="66" y="86" width="68" height="13" rx="3" fill="#b35f40"/>';
      s += '<path d="M100 86c-1-14-1-24 0-30" stroke="#647d69" stroke-width="3" fill="none"/><path d="M100 56c-3-6-14-8-14 1 0 7 10 11 14 16 4-5 14-9 14-16 0-9-11-7-14-1z" fill="#d23a3a"/>';
    } else {
      var bord = g === 'dore' ? '#c9a24a' : (terra ? '#b35f40' : '#ad513f');
      s += '<path d="M58 78h84l-10 82H68z" fill="' + (terra ? '#c4704f' : '#fff') + '"' + (terra ? '' : ' stroke="#e6ddd2"') + '/><rect x="50" y="64" width="100" height="18" rx="3" fill="' + bord + '"/>';
      if (g === 'dore') s += '<rect x="50" y="64" width="100" height="5" rx="2" fill="#e3c779" opacity=".7"/>';
      if (/bougie/.test(g)) s += '<ellipse cx="100" cy="66" rx="44" ry="5" fill="#f6efe2"/><path d="M100 65v-12" stroke="#2a211c" stroke-width="2"/><path d="M100 52c-6-8 0-16 0-21 0 5 6 13 0 21z" fill="#f2c94c"/>';
      if (g === 'kit') s += '<path d="M100 64c0-12 0-18 0-22" stroke="#647d69" stroke-width="3" fill="none"/><path d="M100 46c-9-8-19-3-17 5 8 2 13-1 17-5zM100 50c9-8 19-3 17 5-8 2-13-1-17-5z" fill="#647d69"/>';
    }
    if (mini) return s + '</svg>';
    var milieu = petit ? 128 : 121, tt = texteSvg(msg, petit, milieu, coul);
    s += tt.svg + '<path ' + (petit ? 'transform="translate(100 ' + tt.coeur.toFixed(1) + ') scale(.75) translate(-100 0)" d="M100 0' : 'd="M100 ' + tt.coeur.toFixed(1)) + COEUR + '" fill="' + (terra ? '#fff' : '#c8102e') + '"/>';
    return s + '</svg>';
  }

  function init(R) {
    if (R.dataset.pret) return; R.dataset.pret = '1';

    /* ---- Bandeau date limite (affiché à partir du mois choisi, jusqu'à la date) ---- */
    var lim = R.querySelector('[data-jpo-limite]');
    if (lim) {
      var now = new Date(), j = +lim.dataset.jour, m = +lim.dataset.mois, debut = +lim.dataset.debut || 1;
      var fin = new Date(now.getFullYear(), m - 1, j, 23, 59, 59), mois = now.getMonth() + 1;
      var dansSaison = debut <= m ? (mois >= debut && mois <= m) : (mois >= debut || mois <= m);
      var txt = '';
      if (dansSaison && now <= fin) txt = lim.dataset.avant;
      else if (mois === m && now > fin) txt = lim.dataset.apres;
      if (txt) { lim.textContent = txt; lim.hidden = false; }
    }

    /* ---- Mini-configurateur ---- */
    var box = R.querySelector('.jpo-compo');
    if (box) {
      var cfg = {}; try { cfg = JSON.parse(box.querySelector('[data-jpo-data]').textContent); } catch (e) {}
      var THEMES = (window.JPO_MSG || []).filter(function (o) { return o && o.nom && o.messages; })
        .map(function (o) { return { nom: o.nom, msgs: String(o.messages).split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean) }; });
      function trouverTheme(n) {
        var k = sansAccent(n).trim(); if (!k) return null;
        return THEMES.filter(function (o) { return sansAccent(o.nom) === k; })[0] || THEMES.filter(function (o) { return sansAccent(o.nom).indexOf(k) === 0; })[0] || THEMES.filter(function (o) { return sansAccent(o.nom).indexOf(k) > -1; })[0] || null;
      }
      var avant = String(cfg.avant || '').split(',').map(trouverTheme).filter(Boolean);
      if (!avant.length && THEMES.length) avant = [THEMES[0]];
      var zT = box.querySelector('[data-jpo-themes]'), zM = box.querySelector('[data-jpo-msgs]'), perso = box.querySelector('[data-jpo-perso]');
      var zA = box.querySelector('[data-jpo-apercu]'), go = box.querySelector('[data-jpo-go]');
      var E = { theme: avant[0] || null, msg: '', style: '' };
      if (E.theme) E.msg = E.theme.msgs[0] || '';
      /* onglets : thèmes mis en avant + liste de tous les autres */
      var h = avant.map(function (o, i) { return '<button type="button" class="jpo-theme' + (i === 0 ? ' is-actif' : '') + '" data-t="' + esc(o.nom) + '">' + esc(o.nom.split('/')[0]) + '</button>'; }).join('');
      var autres = THEMES.filter(function (o) { return avant.indexOf(o) < 0; });
      if (autres.length) h += '<label class="jpo-tous"><span class="jpo-cache">' + esc(cfg.tous || 'Tous les thèmes') + '</span><select data-jpo-tous><option value="">' + esc(cfg.tous || 'Tous les thèmes') + '</option>' + autres.map(function (o) { return '<option value="' + esc(o.nom) + '">' + esc(o.nom) + '</option>'; }).join('') + '</select></label>';
      zT.innerHTML = h;
      var sel = zT.querySelector('[data-jpo-tous]');
      function choisirTheme(o, garderMsg) {
        if (!o) return; E.theme = o;
        zT.querySelectorAll('.jpo-theme').forEach(function (b) { b.classList.toggle('is-actif', b.dataset.t === o.nom); });
        if (sel) sel.value = avant.indexOf(o) < 0 ? o.nom : '';
        if (sel) sel.closest('.jpo-tous').classList.toggle('is-actif', avant.indexOf(o) < 0);
        if (!garderMsg && !perso.value.trim()) E.msg = o.msgs[0] || '';
        renduMsgs(); maj();
      }
      function renduMsgs() {
        zM.innerHTML = (E.theme ? E.theme.msgs : []).map(function (m) { return '<button type="button" class="jpo-msg' + (!perso.value.trim() && m === E.msg ? ' is-actif' : '') + '">' + esc(m) + '</button>'; }).join('');
      }
      zT.addEventListener('click', function (e) { var b = e.target.closest('.jpo-theme'); if (b) choisirTheme(trouverTheme(b.dataset.t)); });
      if (sel) sel.addEventListener('change', function () { if (sel.value) choisirTheme(trouverTheme(sel.value)); });
      zM.addEventListener('click', function (e) {
        var b = e.target.closest('.jpo-msg'); if (!b) return;
        perso.value = ''; E.msg = b.textContent; renduMsgs(); maj();
        var deb = E.msg.indexOf('['); if (deb > -1) { perso.value = E.msg; perso.focus(); perso.setSelectionRange(deb, E.msg.indexOf(']', deb) + 1); maj(); }
      });
      perso.addEventListener('input', function () { renduMsgs(); maj(); });
      /* modèles */
      var radios = Array.prototype.slice.call(box.querySelectorAll('.jpo-modele input'));
      box.querySelectorAll('[data-ill]').forEach(function (x) { x.innerHTML = dessin(x.dataset.ill, '', true); });
      radios.forEach(function (r) { r.addEventListener('change', maj); });
      function maj() {
        var r = radios.filter(function (x) { return x.checked; })[0] || radios[0];
        var msg = perso.value.trim() || E.msg || cfg.ph || '';
        zA.innerHTML = dessin(r ? (r.dataset.kit ? 'kit' : r.value) : '', msg);
        if (!r || !go) return;
        var p = [];
        if (!r.dataset.kit && r.dataset.style) p.push('style=' + encodeURIComponent(r.dataset.style));
        if (E.theme) p.push('occasion=' + encodeURIComponent(E.theme.nom));
        if (perso.value.trim() || E.msg) p.push('message=' + encodeURIComponent(perso.value.trim() || E.msg));
        go.href = r.dataset.url + (p.length ? (r.dataset.url.indexOf('?') > -1 ? '&' : '?') + p.join('&') : '');
      }
      aRedessiner.push(maj);
      chargerPolice();
      renduMsgs(); maj();
      /* « Voir les messages » depuis les encarts « Pour qui ? » */
      R.addEventListener('click', function (e) {
        var b = e.target.closest('[data-jpo-theme]'); if (!b) return;
        var o = trouverTheme(b.dataset.jpoTheme); if (!o) return;
        perso.value = ''; choisirTheme(o);
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ---- Bouton du haut : arrivée juste sous l'en-tête fixe du thème ---- */
    function hauteurEntete() {
      var h = 0;
      document.querySelectorAll('header, .Header, #shopify-section-header, [data-section-type="header"]').forEach(function (el) {
        var st = getComputedStyle(el); if (st.position !== 'fixed' && st.position !== 'sticky') return;
        var r = el.getBoundingClientRect(); if (r.top <= 5 && r.bottom > h && r.bottom < 300) h = r.bottom;
      });
      return h;
    }
    R.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#jpo-composer"]'); if (!a) return;
      var sec = document.getElementById('jpo-composer'); if (!sec) return;
      e.preventDefault();
      var c = sec.querySelector('.jpe-sur') || sec.querySelector('h2') || sec;
      var y = function () { return c.getBoundingClientRect().top + window.pageYOffset - Math.max(hauteurEntete(), 90) - 28; };
      window.scrollTo({ top: Math.max(0, y()), behavior: 'smooth' });
      setTimeout(function () { if (Math.abs(y() - window.pageYOffset) > 8) window.scrollTo({ top: Math.max(0, y()), behavior: 'smooth' }); }, 700);
    });

    /* ---- Lire la suite ---- */
    R.addEventListener('click', function (e) {
      var b = e.target.closest('[data-jpo-seo]'); if (!b) return;
      var z = document.getElementById(b.getAttribute('aria-controls')); if (!z) return;
      var ouvert = b.getAttribute('aria-expanded') === 'true';
      if (ouvert) { z.style.maxHeight = z.scrollHeight + 'px'; z.classList.remove('is-ouvert'); requestAnimationFrame(function () { z.style.maxHeight = '0px'; }); }
      else { z.style.maxHeight = z.scrollHeight + 'px'; setTimeout(function () { z.classList.add('is-ouvert'); z.style.maxHeight = ''; }, 360); }
      b.setAttribute('aria-expanded', ouvert ? 'false' : 'true'); b.textContent = ouvert ? b.dataset.plus : b.dataset.moins;
    });
  }
  function lancer() { document.querySelectorAll('.jpo').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer); else lancer();
  document.addEventListener('shopify:section:load', lancer);
})();
